import { css } from "@emotion/react";

export const scrollAreaStyle = css`
  height: 100%;
  overflow: auto;
`;

export const tableStyle = css`
  background: #fff;
  padding: 16px;
`;

export const configCellStyle = css`
  margin-bottom: 0 !important;
`;

export const fullWidthItemStyle = css`
  width: 100%;
`;

export const actionIconStyle = css`
  font-size: 10px;
`;

export const searchInputStyle = css`
  width: 300px;
  vertical-align: middle;
`;

export const nameCellStyle = css`
  display: inline-flex;
  align-items: center;
`;

// Depth-based indent for nested name cells (base = 0).
export const nameIndentStyle = (depth: number) => css`
  padding-left: ${depth * 24}px;
`;

// Faint tree connector shown before nested (depth > 0) names.
export const treeConnectorStyle = css`
  margin-right: 6px;
  color: #bfbfbf;
  user-select: none;
`;

export const tableHeaderStyle = css`
  .ant-table-thead > tr > th {
    font-weight: bold;
  }
`;
